﻿'use strict';

angular.module('ntmApp')
  .controller('eventFormDialogController', ['$scope', '$uibModalInstance', 'data', 'FlashService', 'Utils', 'EditForm', 'FormService', 'ListGridConstants',
      function ($scope, $uibModalInstance, data, FlashService, Utils, EditForm, FormService, ListGridConstants) {
          
          $scope.close = function (event) {

              if (!$scope.editForm.form.$dirty) {
                  $uibModalInstance.dismiss();
              } else {
                  event.preventDefault();
                  var modal = Utils.OpenModal('Save pending changes?', 'ng1/src/common/confirmationModal.html', 'ModalController');

                  modal.result.then(function (leave) {
                      if (leave === 'no') {
                          $uibModalInstance.dismiss();
                      } else if (leave === 'yes') {
                          if (!$scope.editForm.form.$valid) {
                              FlashService.Error('Please, fill all required fields', true);
                          } else {
                              $scope.editForm.SaveData();
                              $uibModalInstance.dismiss();
                          }
                      }
                  });
              }
          };

          $scope.dismiss = function () {
              $uibModalInstance.dismiss();
          };

          $scope.$on('modal.closing', function (event, reason) {
              if (reason === 'backdrop click') {
                  event.preventDefault();
                  $scope.close();
              }
          });

          function onDataUpdatedMethod() {
              $uibModalInstance.dismiss();

              data.updateMethod();
          }

          function prepareFormData(result) {

              if (!result.isViewPrimaryKey) {
                  result.generalPageSection.forEach(function (section) {
                      section.sectionAttributes.forEach(function (field) {
                          field.protect = true;
                      });
                  });
              }

              result.model = data.calendarEvent.eventData ? data.calendarEvent.eventData.data : data.calendarEvent.data;
              result.action = ListGridConstants.Operation.EDIT;
              result.pageType = ListGridConstants.SectionType.Calendar;
              result.doNotReset = true;
              result.onDataUpdatedMethod = onDataUpdatedMethod;
              result.close = $scope.close;
          }

          function initData() {
              $scope.dataLoaded = false;
			  
			  var requestData = {
			      id: data.eventFormHtmlPageId
		      };

              FormService.GetForm(requestData).then(function (result) {
				  
				  result.data.hideCancelBtn = true;

                  prepareFormData(result.data);

                  $scope.editForm = new EditForm(result.data);

                  $scope.dataLoaded = true;
              });
          }

          initData();

      }]);